export class IEmailFields {
   to: string;
   subject: string;
   body: string;
}
